import script from "./SignPannel.vue?vue&type=script&lang=ts"
export * from "./SignPannel.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__